/**
 * Kuwaiti dinar formatting.
 *
 * The site shows the local "KD" label, but "KD" is not an ISO 4217 code:
 * Intl.NumberFormat throws `RangeError: Invalid currency code` for it, which
 * takes the whole screen down. Format the number and add the label ourselves.
 */

export const CURRENCY_LABEL = 'KD';

const numberFormatter = new Intl.NumberFormat('en-KW', {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3
});

export const formatCurrency = (amount, { label = CURRENCY_LABEL } = {}) => {
  const value = Number(amount);
  return `${label} ${numberFormatter.format(Number.isFinite(value) ? value : 0)}`;
};

export default formatCurrency;
